/* eslint-disable import/prefer-default-export */
import { api } from '$app/api';

export const listAllProducts = () =>
  api
    .post(`/product`, {
      eventType: 'ListProductsRequest',
      body: {},
    })
    .then((res) => res.data.map((d) => d.sku));
